class DetailsModal extends HTMLElement {
  constructor() {
    super();
    // 增加空值检查，避免 DOM 结构不完整时报错
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    const closeButton = this.querySelector('button[type="button"]');

    // 初始化焦点陷阱的事件处理器对象，避免全局污染
    this.trapFocusHandlers = {};

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  // 新增：获取所有可聚焦元素的辅助方法（原代码中缺失）
  getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [contenteditable], input:not([type="hidden"]):enabled, select:enabled, textarea:enabled'
      )
    );
  }

  removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', this.trapFocusHandlers.focusin);
    document.removeEventListener('focusout', this.trapFocusHandlers.focusout);
    document.removeEventListener('keydown', this.trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }

  trapFocus(container, elementToFocus = container) {
    // 确保调用的是类实例上的 getFocusableElements
    const elements = this.getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];

    // 确保使用 this 调用类方法
    this.removeTrapFocus();

    this.trapFocusHandlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', this.trapFocusHandlers.keydown);
    };

    this.trapFocusHandlers.focusout = () => {
      document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
    };

    this.trapFocusHandlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return; // 如果不是 TAB 键直接返回

      // 在最后一个可聚焦元素上按 TAB（向前），焦点回到第一个元素
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        if (first) first.focus();
      }

      // 在第一个可聚焦元素或容器上按 Shift + TAB（向后），焦点跳到最后一个元素
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        if (last) last.focus();
      }
    };

    document.addEventListener('focusout', this.trapFocusHandlers.focusout);
    document.addEventListener('focusin', this.trapFocusHandlers.focusin);

    if (elementToFocus) {
      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    }
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // 添加容错处理，确保在元素不存在时备用方案生效
    const trapContainer = this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer;
    const inputToFocus = this.detailsContainer.querySelector('input:not([type="hidden"])');
    
    // 使用 this.trapFocus 调用方法
    this.trapFocus(trapContainer, inputToFocus || trapContainer);
  }

  close(focusToggle = true) {
    // 使用 this.removeTrapFocus
    this.removeTrapFocus(focusToggle ? this.summaryToggle : null);
    
    if (this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
    }
    
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}


customElements.define('details-modal', DetailsModal);